import * as React from 'react';
import {observer} from 'mobx-react-lite';
import styled from '@emotion/styled';
import {mainColors} from '../colors';

interface PropsType {
    className?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const FolderPlusIcon = observer(( {className}: PropsType ): React.ReactElement => (
    <SvgWrapper width={16} height={15} className={className} fill={mainColors.default.light} >
        <path d='M5.6 0l1.6 2.4h7.2A1.6 1.6 0 0116 4v9.4a1.6 1.6 0 01-1.6 1.6H1.6A1.6 1.6 0 010 13.4V1.6A1.6 1.6 0 011.6 0h4zM4.53 2H2v11h12V4.4H7.2a2 2 0 01-1.664-.89L4.53 2zM8 5.85a.75.75 0 01.75.75v1.35h1.35a.75.75 0 01.743.648l.007.102a.75.75 0 01-.75.75H8.75v1.35a.75.75 0 01-.648.743L8 11.55a.75.75 0 01-.75-.75V9.45H5.9a.75.75 0 01-.743-.648L5.15 8.7a.75.75 0 01.75-.75h1.35V6.6a.75.75 0 01.648-.743z'/>
    </SvgWrapper>
));
